import { Icon } from '../../../../ui-library/icon/icon';
import { IconTile, type IconTileSize } from '../shared/settings/icon-tile';
import { getFloraSettingsNavItem } from './agent-settings.constants';
import type { FloraSettingsSection } from './agent-settings.type';

interface SettingsSectionIconProps {
  section: FloraSettingsSection;
  /** `sm` for the menu, `xl` for a page heading. Defaults to `xl`. */
  size?: IconTileSize;
}

const GLYPH_SIZES: Partial<Record<IconTileSize, number>> = { xs: 14, sm: 18, md: 20, lg: 24, xl: 28 };

/**
 * Renders a settings section's coloured icon tile, so the menu and the page
 * heading always show the same icon and colours.
 *
 * @param {SettingsSectionIconProps} props - The section and tile size
 * @returns {JSX.Element} The section's icon tile
 *
 * @example
 * <SettingsSectionIcon section={FloraSettingsSection.Tools} />
 */
export function SettingsSectionIcon({ section, size = 'xl' }: SettingsSectionIconProps) {
  const item = getFloraSettingsNavItem(section);

  return (
    <IconTile background={item.tileBackground} size={size}>
      {/* Inherit the cursor: a pointer inside the menu links, the default on page headings. */}
      <Icon name={item.icon} size={GLYPH_SIZES[size] ?? 20} color={item.tileColor} style={{ cursor: 'inherit' }} />
    </IconTile>
  );
}

export type { SettingsSectionIconProps };
